/* esm.sh - zod@4.4.3/v4/core/to-json-schema */
export * from "/*zod@4.4.3/esnext/v4/core/to-json-schema.mjs";
